import React, { useState } from "react";
import "./popvip.css";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Popupvip = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const vipLevels = [
  {
    name: "Bronze",
    range: "VIP 2-7",
    color: "#CD7F32",
    details: "Bronze members get access to basic features.",
    image: "assets/bcimages/bonus/popvip1.png",
    icon: "assets/bcimages/bonus/small-badge-bronze.webp",
    xp: [100, 200, 1000, 2000, 3000, 4000], // Dynamic XP values
  },
  { 
    name: "Silver",
    range: "VIP 8-21",
    color: "#C0C0C0",
    details: "Silver members enjoy additional discounts and benefits.",
    image: "assets/bcimages/bonus/popvip2.png",
    icon: "assets/bcimages/bonus/small-badge-silver.png",
    xp: [5000, 7000, 10000, 15000, 20000, 30000],
  },
  {
    name: "Gold",
    range: "VIP 22-37",
    color: "#FFD700",
    details: "Gold members receive premium support and exclusive perks.",
    image: "assets/bcimages/bonus/popvip3.png",
    icon: "assets/bcimages/bonus/small-badge-#9fe871.webp",
    xp: [40000, 50000, 60000, 80000, 100000, 120000],
  },
  {
    name: "Platinum I",
    range: "VIP 38-55",
    color: "#E5E4E2",
    details: "Platinum I members have VIP event invitations.",
    image: "assets/bcimages/bonus/popvip4.png",
    icon: "assets/bcimages/bonus/small-badge-platinum.webp",
    xp: [150000, 200000, 250000, 300000, 400000, 500000],
  },
  {
    name: "Platinum II",
    range: "VIP 56-69",
    color: "#E5E4E2",
    details: "Platinum I members have VIP event invitations.",
    image: "assets/bcimages/bonus/popvip4.png",
    icon: "assets/bcimages/bonus/small-badge-platinum.webp",
     xp: [600000, 800000, 1000000, 1200000, 1500000, 2000000],
  },

  {
    name: "Diamond I",
    range: "SVIP 1-15",
    color: "#b9f2ff",
    details: "Diamond I members have access to luxury benefits.",
    image: "assets/bcimages/bonus/popvip5.png",
    icon: "assets/bcimages/bonus/small-badge-diamond.webp",
    xp: [600000, 800000, 1000000, 1200000, 1500000, 2000000],
  },
  
  {
    name: "Diamond II",
    range: "SVIP 16-37",
    color: "#b9f2ff",
    details: "Diamond I members have access to luxury benefits.",
    image: "assets/bcimages/bonus/popvip5.png",
    icon: "assets/bcimages/bonus/small-badge-diamond.webp",
    xp: [600000, 800000, 1000000, 1200000, 1500000, 2000000],
  },
  {
    name: "Diamond III",
    range: "SVIP 38-75",
    color: "#b9f2ff",
    details: "Diamond I members have access to luxury benefits.",
    image: "assets/bcimages/bonus/popvip5.png",
    icon: "assets/bcimages/bonus/small-badge-daimond.webp",
    xp: [600000, 800000, 1000000, 1200000, 1500000, 2000000],
  },
];

  return (
   <div>
    <div onClick={handleOpenPopup} className="about-vip-level">
      View Level Up Details
    </div>

    {isPopupOpen && (
      <div className="vip-popup-component">
        <div className="vip2-popup">
          <div className="vip2-popup-page" style={{color:'#fff'}}>
            <div className="vip2-popup-page-btn" onClick={handleClosePopup}>
              X
            </div>
            VIP Level System
          </div>
          <div className="vip-levels-list" style={{textAlign:'left'}}>
            {vipLevels.map((level, index) => (
              <div key={index} className="vip-level-item">
                <div
                  className="vip-level-header"
                  onClick={() => toggleDropdown(index)}
                >
                  <div style={{ position: "relative" }}>
                    <img
                      className="image-label-in"
                      src={level.image}
                      alt={`${level.name} Icon`}
                    />
                  </div>
                  <span className="vip-level-text">
                    {level.name} <span>{level.range}</span>
                  </span>
                  <span className="vip-level-arrow">
                    {activeDropdown === index ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowRightIcon />
                    )}
                  </span>
                </div>
                {activeDropdown === index && (
                  <div className="vip-level-details">
                    <div className="vip-level-details-inner">
                      <div>Level</div>
                      <div>Required XP</div>
                    </div>
                    {level.xp.map((xpValue, idx) => (
                      <div
                        key={idx}
                        className={`vip-level-details-img-text ${
                          idx % 2 === 0 ? "bg-dark" : ""
                        }`}
                      >
                        <div className="vip-level-details-imgage">
                          <img
                            style={{ width: "20px" }}
                            src={level.icon}
                            alt="level-icon"
                          />
                          <div>VIP {index * 6 + idx + 2}</div>
                        </div>
                        <div>{xpValue}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
  </div>
  );
};

export default Popupvip;
